import { EngineMessageErrorType, Message } from '@surveycake/logic-engine';
import {
  useEngineMessage,
  UseEngineMessageSelector
} from '@surveycake/react-logic-engine';
import { Exception, ExceptionService, ExceptionStatus } from 'app/core/status';
import { useEffect } from 'react';

const messageSelector: UseEngineMessageSelector<
  Message<EngineMessageErrorType, undefined>
> = message => message.error;

export function useSubscribeEngineMessage() {
  const setException = ExceptionService.useSetException();
  const error = useEngineMessage(messageSelector);

  useEffect(() => {
    if (error.type in ExceptionStatus) {
      setException(new Exception(error.type));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.type]);
}
